import { accordion } from "./_accordion";
import { animation } from "./_animation";
import { headerMv } from "./_headerMv";
import { countUp } from "./_countUp";
import { common } from "./_common";
import { drawer } from "./_drawer";
import { slide } from "./_slide";
import { modal } from "./_modal";
import { test } from "./_test";
import { tab } from "./_tab";

accordion();
animation();
// countUp();
// common();
drawer();
headerMv();
slide();
// modal();
// test();
tab();